import { createAction } from '@reduxjs/toolkit';

enum ActionType {
  SEND_HTTP_REQUEST = 'SEND_HTTP_REQUEST',
  USER_INFO = 'USER_INFO',
  AUTHENTICATE_LOGIN = 'AUTHENTICATE_LOGIN',
}

export const actionSendHttpRequest = createAction<any | undefined>(
  ActionType.SEND_HTTP_REQUEST,
);

export default ActionType;
